// ModalAreaPix.jsx
import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { api } from "../../api/api";
import { Alert, AlertErro } from "../../../util/Alertas";
import { QRCodeCanvas } from "qrcode.react";

const ModalPorcentagemComissao = forwardRef(function PorcentagemComissao(props, ref) {
    const [show, setShow] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [porcentagem, setPorcentagem] = useState(0);

    useImperativeHandle(
        ref,
        () => ({
            openModal: (id) => {
                setCurrentId(id ?? null);
                api.get(`/api/Pedido/BuscarComissao/${id}`, (res) => {
                    setPorcentagem(res.data);
                    setShow(true);
                });
            },
            close: () => setShow(false),
            getId: () => currentId,
        }),
        [currentId]
    );

    const handleClose = () => setShow(false);

    const handleSave = () => {
        api.post(`/api/Pedido/AlterarComissao/${currentId}`, {
            porcentagem
        }, res => {
            Alert('Comissão alterada com sucesso!');
            handleClose();
        },err=> {
            AlertErro(err, 'Erro ao alterar a comissão!');
        })
    }

    const handleDescontoPercentualChange = (event) => {
        const inputValue = event.target.value;
        if (/^\d*\.?\d*$/.test(inputValue) || inputValue === "") {
            const percentual = inputValue === "" ? "" : parseFloat(inputValue);
            if (percentual >= 0 && percentual <= 100) {
                setPorcentagem(percentual);
            }
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Detalhes {currentId != null ? `#${currentId}` : ""}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <label htmlFor="">Informe a porcentagem da comissão deste pedido</label>
                <input type="text" className="form-control" value={porcentagem} onChange={handleDescontoPercentualChange} />
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
                <Button onClick={handleSave}>
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
});

export default ModalPorcentagemComissao;
